/* Spooky season images are separate WebP files. Shopify fills the URLs when this file is served. */
window.hwMoonImg = "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-moon.webp?v=35863395976536308901793011223";
window.hwWitchImg = "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-witch.webp?v=98493965935940680011793011222";
window.hwPusherImg = "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pusher.webp?v=148334080603389433261793011222";
window.hwPumpkins = [
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin-0.webp?v=177414230438231563441793011223", cx: 0.5082417582417582, cy: 0.7158351409978309, d: 0.6318681318681318, ar: 1.2664835164835164 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin-1.webp?v=140641470834170692691793011223", cx: 0.524547803617571, cy: 0.65406162464986, d: 0.5917312661498708, ar: 0.9224806201550387 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin-2.webp?v=55887133607547488191793011223", cx: 0.5434782608695652, cy: 0.7291666666666666, d: 0.5703324808184144, ar: 1.1662404092071612 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin-3.webp?v=43482985010883731371793011223", cx: 0.5086633663366337, cy: 0.7334963325183375, d: 0.49504950495049505, ar: 1.0123762376237624 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin-4.webp?v=176245366980136305291793011223", cx: 0.5223325062034739, cy: 0.6928020565552699, d: 0.533498759305211, ar: 0.9652605459057072 }
];
window.hwPumpkins2 = [
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-0.webp?v=36091370652888442171793011223", ar: 1.1485148514851484, bt: 0.2413793103448276, bb: 0.9482758620689655, cx: 0.4975247524752475 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-1.webp?v=65363030623384796971793011222", ar: 1.9276315789473684, bt: 0.28668941979522183, bb: 0.9488054607508533, cx: 0.4967105263157895 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-2.webp?v=99524357149576574661793011223", ar: 0.8909090909090909, bt: 0.24489795918367346, bb: 0.9438775510204082, cx: 0.5022727272727273 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-3.webp?v=114303378454500880511793011222", ar: 1.576470588235294, bt: 0.26492537313432835, bb: 0.9514925373134329, cx: 0.5029411764705882 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-4.webp?v=35079911327200482891793011222", ar: 1.1791044776119404, bt: 0.270042194092827, bb: 0.9451476793248945, cx: 0.4975124378109453 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-5.webp?v=111372047420663981671793011222", ar: 1.6745562130177514, bt: 0.23674911660777384, bb: 0.950530035335689, cx: 0.4911242603550296 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-6.webp?v=71215742921193293051793011222", ar: 1.0730593607305936, bt: 0.28936170212765955, bb: 0.948936170212766, cx: 0.502283105022831 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-7.webp?v=10088448465166497001793011222", ar: 1.7647058823529411, bt: 0.31333333333333335, bb: 0.94, cx: 0.49117647058823527 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-8.webp?v=103157959319831101551793011222", ar: 1.1473684210526316, bt: 0.25688073394495414, bb: 0.9357798165137615, cx: 0.4921052631578947 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-9.webp?v=71550699531488803331793011222", ar: 1.5621621621621622, bt: 0.28027681660899656, bb: 0.9480968858131488, cx: 0.4972972972972973 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-10.webp?v=127188800125667893121793011223", ar: 0.796, bt: 0.24623115577889448, bb: 0.9447236180904522, cx: 0.498 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-11.webp?v=137016620123918562931793011222", ar: 1.5833333333333333, bt: 0.2596491228070175, bb: 0.9473684210526315, cx: 0.49722222222222223 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-12.webp?v=174180330636375120491793011222", ar: 1.0845771144278606, bt: 0.28440366972477066, bb: 0.944954128440367, cx: 0.4975124378109453 },
  { src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-pumpkin2-13.webp?v=5433314224483636871793011223", ar: 1.825, bt: 0.339041095890411, bb: 0.952054794520548, cx: 0.503125 }
];
window.hwPapBats = [
  { ar: 0.5350404312668463, lp: [0.2871293800539083,0.5525188916876574], rp: [0.7128706199460917,0.5525188916876574], body: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-0-body.webp?v=172051252554998635971793011222", root: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-0-root.webp?v=125818683222646891721793011222", lw: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-0-lw.webp?v=179532942375551923401793011222", rw: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-0-rw.webp?v=175566327047664154751793011223" },
  { ar: 0.553133514986376, lp: [0.2848092643051771,0.5624384236453202], rp: [0.7151907356948229,0.5624384236453202], body: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-1-body.webp?v=155691271648523996191793011223", root: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-1-root.webp?v=39957191671001606171793011223", lw: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-1-lw.webp?v=59560460559561751371793011223", rw: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-1-rw.webp?v=159677634743656107721793011223" },
  { ar: 0.575, lp: [0.28062499999999996,0.5708937198067633], rp: [0.7193750000000001,0.5708937198067633], body: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-2-body.webp?v=82225615316308306261793011223", root: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-2-root.webp?v=137105662092698396911793011223", lw: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-2-lw.webp?v=130602663941370251121793011223", rw: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-bat-2-rw.webp?v=134093704912115596011793011223" }
];
window.hwShadowSprites = {
  bat_big: { w: 216, h: 128, src: "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-shadow-bat.webp?v=64793538395246506071793011222" }
};
window.hwFogImg = "\/\/staleks.pl\/cdn\/shop\/t\/12\/assets\/spooky-fog.webp?v=68085342726387972631793011223";

/* STALEKS Halloween – "something is behind the photo".
   In every second row of the product grid one card at a time shows the soft shadow of a cute Halloween
   bats (silhouettes from hw_sprites.js) standing outside the frame: it appears, moves and fades, then another card in that row takes over.
   Works on any product grid (collections, search): it only needs .product-card with an image wrapper.
   The photos, titles, prices and buttons are not touched – the shadow is a separate layer with multiply blending. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CARD_SEL = 'main .product-card';
  var MEDIA_SEL = '.product-card__image-wrapper';

  // ---------- small helpers ----------
  function f(n) { return Math.round(n * 100) / 100; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function seg(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }
  function ease(t) { return t * t * (3 - 2 * t); }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function seeded(s) { return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; }; }
  function el(tag, attrs, parent) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function path(d, parent, extra) { var a = { d: d }; for (var k in extra) a[k] = extra[k]; return el('path', a, parent); }
  // tapered limb with round ends from (x1,y1) to (x2,y2)
  function cap(x1, y1, x2, y2, w1, w2) {
    var dx = x2 - x1, dy = y2 - y1, L = Math.sqrt(dx * dx + dy * dy) || 1, nx = -dy / L, ny = dx / L, r1 = w1 / 2, r2 = w2 / 2;
    return 'M' + f(x1 + nx * r1) + ' ' + f(y1 + ny * r1) + 'L' + f(x2 + nx * r2) + ' ' + f(y2 + ny * r2) +
      'A' + f(r2) + ' ' + f(r2) + ' 0 0 0 ' + f(x2 - nx * r2) + ' ' + f(y2 - ny * r2) +
      'L' + f(x1 - nx * r1) + ' ' + f(y1 - ny * r1) +
      'A' + f(r1) + ' ' + f(r1) + ' 0 0 0 ' + f(x1 + nx * r1) + ' ' + f(y1 + ny * r1) + 'Z';
  }
  // joint = group that rotates around its own origin; position is in the parent's coordinates
  function joint(parent, x, y, a) { var g = el('g', {}, parent); g._x = x; g._y = y; g._a = a || 0; pose(g, 0); return g; }
  function pose(g, da, dx, dy, s) {
    g.setAttribute('transform', 'translate(' + f(g._x + (dx || 0)) + ' ' + f(g._y + (dy || 0)) + ') rotate(' + f(g._a + (da || 0)) + ')' + (s && s !== 1 ? ' scale(' + f(s) + ')' : ''));
  }
  // ---------- the creatures (drawn entering from the LEFT side; mirrored for the right) ----------
  var CREATURES = {};

  // ---------- silhouettes (cut from the Halloween shadow sheet, see hw_sprites.js) ----------
  function spr(parent, name, k, ax, ay) {
    var S = (window.hwShadowSprites || {})[name], g = joint(parent, 0, 0, 0);
    if (!S) return g;
    var w = S.w * k, h = S.h * k;
    el('image', { href: S.src, x: f(-w * ax), y: f(-h * ay), width: f(w), height: f(h), preserveAspectRatio: 'none' }, g);
    return g;
  }
  function put(g, x, y, rot, s, op, sx) {
    g._x = x; g._y = y; g._a = 0;
    g.setAttribute('transform', 'translate(' + f(x) + ' ' + f(y) + ') rotate(' + f(rot || 0) + ') scale(' + f((s == null ? 1 : s) * (sx || 1)) + ' ' + f(s == null ? 1 : s) + ')');
    g.setAttribute('opacity', f(op == null ? 1 : op));
  }
  function xfade(p, a, b) { return ease(seg(p, a, b)); }
  function sparkle(parent) { return path('M0 -3.2L.8 -.8 3.2 0 .8 .8 0 3.2 -.8 .8 -3.2 0 -.8 -.8Z', parent, { fill: 'rgb(40,28,64)' }); }
  var STILL = { x: 0, y: 0, rot: 0, s: 1 };

  function flapY(t, sp, ph) { return .5 + .5 * Math.abs(Math.cos(t * sp + (ph || 0))); }
  // little bats circle around and flutter away upwards
  CREATURES.batswarm = {
    dur: 7200, place: STILL,
    build: function (g) {
      var r = { bs: [] };
      [[.11, 0], [.09, 1.9], [.13, 3.6], [.08, 5.1]].forEach(function (q) { r.bs.push({ g: spr(g, 'bat_big', q[0], .5, .55), ph: q[1], s: q[0] }); });
      return r;
    },
    frame: function (r, p, t) {
      var inn = easeOut(seg(p, 0, .3)), out = ease(seg(p, .72, 1));
      r.bs.forEach(function (o, i) {
        var a = t * .9 + o.ph, rx = 24 + i * 3, ry = 12 + i * 2;
        var cx = 34 + (1 - inn) * -60 + out * (i % 2 ? 70 : -60), cy = 46 - out * 70 + (1 - inn) * 30;
        var x = cx + Math.cos(a) * rx, y = cy + Math.sin(a) * ry;
        o.g.setAttribute('transform', 'translate(' + f(x) + ' ' + f(y) + ') rotate(' + f(Math.cos(a) * 14) + ') scale(' + (Math.sin(a) < 0 ? -1 : 1) + ' ' + f(flapY(t, 8 + i, i)) + ')');
      });
    },
    shape: function () { return { skew: -5, sy: 1, blur: .9 }; }
  };

  var ORDER = ['batswarm'];

  // ---------- photo brightness (shadows must read on light AND dark photos) ----------
  function brightness(img, cb) {
    if (img._hwLum != null) return cb(img._hwLum);
    function done(v) { img._hwLum = v; cb(v); }
    try {
      var c = document.createElement('canvas'); c.width = c.height = 24;
      var x = c.getContext('2d');
      var test = function (src) {
        x.drawImage(src, 0, 0, 24, 24);
        var d = x.getImageData(0, 0, 24, 24).data, s = 0;
        for (var i = 0; i < d.length; i += 4) s += .3 * d[i] + .59 * d[i + 1] + .11 * d[i + 2];
        done(s / (d.length / 4) / 255);
      };
      if (/^data:|^blob:/.test(img.currentSrc || img.src)) return test(img);
      // other origins: needs CORS (Shopify CDN sends it); otherwise assume a light photo
      fetch(img.currentSrc || img.src, { mode: 'cors' }).then(function (rs) { return rs.blob(); }).then(createImageBitmap).then(test).catch(function () { done(.8); });
    } catch (e) { done(.8); }
  }

  // ---------- one scene inside a card ----------
  var sceneN = 0;
  function makeScene(card, kind, fromRight, lum) {
    var wrap = card.querySelector(MEDIA_SEL);
    var img = wrap.querySelector('.product-card__image--main img') || wrap.querySelector('img');
    var C = CREATURES[kind];
    var layer = document.createElement('div');
    layer.className = 'hw-sh-layer';
    var radius = getComputedStyle(img.closest('.media-wrapper') || img).borderRadius;
    if (radius && radius !== '0px') layer.style.borderRadius = radius;
    var dark = clamp((.62 - lum) / .45, 0, 1);              // 0 = light photo, 1 = very dark photo
    // moonlight patch – invisible on light photos, makes the shadow readable on dark ones
    var moon = document.createElement('div'); moon.className = 'hw-sh-moon'; moon.style.opacity = '0';
    layer.appendChild(moon);
    var id = 'hwsc' + (++sceneN);
    var svg = el('svg', { viewBox: '0 0 100 100', preserveAspectRatio: 'xMidYMid slice', 'aria-hidden': 'true', focusable: 'false' });
    var defs = el('defs', {}, svg);
    var flt = el('filter', { id: id, x: '-30%', y: '-30%', width: '160%', height: '160%', 'color-interpolation-filters': 'sRGB' }, defs);
    var blurEl = el('feGaussianBlur', { stdDeviation: '2' }, flt);
    var ink = el('g', { filter: 'url(#' + id + ')', fill: '#120a1f' }, svg);
    var mirror = el('g', { transform: fromRight ? 'translate(100 0) scale(-1 1)' : '' }, ink);
    var shape = el('g', {}, mirror);
    var sc = C.place.s * rand(.94, 1.08);
    var placeG = el('g', { transform: C.mirrorDefault ? 'translate(' + (100 - C.place.x) + ' ' + C.place.y + ') scale(' + f(-sc) + ' ' + f(sc) + ')'
      : 'translate(' + C.place.x + ' ' + C.place.y + ') rotate(' + C.place.rot + ') scale(' + f(sc) + ')' }, shape);
    var rig = C.build(placeG, seeded(Math.floor(rand(1, 9999))));
    layer.appendChild(svg);
    var link = wrap.querySelector('a');
    if (link && link.parentNode === wrap) wrap.insertBefore(layer, link.nextSibling); else wrap.appendChild(layer);
    var strength = lerp(.34, .6, dark);
    svg.style.opacity = '0';
    return {
      layer: layer, dur: C.dur * rand(.95, 1.08),
      render: function (p, tt) {
        C.frame(rig, p, tt);
        var sh = C.shape(p);
        shape.setAttribute('transform', 'translate(50 100) skewX(' + f(sh.skew) + ') scale(1 ' + f(sh.sy) + ') translate(-50 -100)');
        blurEl.setAttribute('stdDeviation', f(sh.blur + .4));
        var fade = ease(seg(p, 0, .12)) * (1 - ease(seg(p, .82, 1)));
        svg.style.opacity = f(strength * fade);
        moon.style.opacity = f(dark * .45 * fade);
      }
    };
  }
  function imgOf(card) { var w = card.querySelector(MEDIA_SEL); return w && (w.querySelector('.product-card__image--main img') || w.querySelector('img')); }
  function playScene(card, kind, fromRight, onEnd) {
    var img = imgOf(card);
    if (!img) { onEnd(); return; }
    brightness(img, function (lum) {
      var S = makeScene(card, kind, fromRight, lum), t0 = null;
      function step(now) {
        if (!t0) t0 = now;
        var p = (now - t0) / S.dur;
        if (p >= 1 || !S.layer.isConnected) { S.layer.remove(); onEnd(); return; }
        S.render(p, (now - t0) / 1000);
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }
  // test helper: a frozen frame of a scene
  function still(card, kind, fromRight, p) {
    var img = imgOf(card);
    brightness(img, function (lum) { var S = makeScene(card, kind, fromRight, lum); S.render(p, p * S.dur / 1000); });
  }

  // ---------- director: one shadow per row of cards ----------
  var running = false, timer, kindI = Math.floor(Math.random() * ORDER.length);
  var rowState = {};                       // row key → { busy, next, last }
  var active = [];                         // creatures currently on screen (so neighbouring rows differ)
  var EVERY = 2;                           // bats in every 2nd row of the grid (1st, 3rd, 5th…)
  function rows() {
    var hdr = document.querySelector('.header-section');
    var top = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
    var all = {}, map = {};
    Array.prototype.forEach.call(document.querySelectorAll(CARD_SEL), function (c) {
      var w = c.querySelector(MEDIA_SEL); if (!w) return;
      var r = w.getBoundingClientRect(); if (r.width < 60) return;
      var key = Math.round((r.top + scrollY) / 20);
      (all[key] = all[key] || []).push({ c: c, r: r });
    });
    Object.keys(all).map(Number).sort(function (a, b) { return a - b; }).forEach(function (key, idx) {
      if (idx % EVERY) return;
      all[key].forEach(function (o) {
        var r = o.r;
        if (r.bottom < top + r.height * .5 || r.top > innerHeight - r.height * .5) return;   // at least half visible
        (map[key] = map[key] || []).push(o.c);
      });
    });
    return map;
  }
  function nextKind() {
    for (var n = 0; n < ORDER.length; n++) { var k = ORDER[kindI++ % ORDER.length]; if (active.indexOf(k) < 0) return k; }
    return ORDER[kindI++ % ORDER.length];
  }
  function tick() {
    clearTimeout(timer);
    timer = setTimeout(tick, 700);
    if (document.hidden || !root.classList.contains('hw-on')) return;
    var now = Date.now(), map = rows();
    Object.keys(map).forEach(function (key) {
      var st = rowState[key] = rowState[key] || { busy: false, next: now + rand(0, 2500), last: null };
      if (st.busy || now < st.next) return;
      var cards = map[key].filter(function (c) { return c !== st.last; });
      if (!cards.length) cards = map[key];
      var card = cards[Math.floor(Math.random() * cards.length)];
      var kind = nextKind();
      st.busy = true; st.last = card; active.push(kind);
      playScene(card, kind, Math.random() < .5, function () {
        st.busy = false; st.next = Date.now() + rand(2500, 5000);
        active.splice(active.indexOf(kind), 1);
      });
    });
  }
  var root = document.documentElement;
  window.hwShadows = {
    start: function () {
      if (running || reduced || !document.querySelector(CARD_SEL)) return;
      running = true;
      timer = setTimeout(tick, 1200);
    },
    play: playScene, still: still,            // for testing: hwShadows.play(card, 'werewolf', false, function(){})
    creatures: ORDER
  };
})();

/* ===== STALEKS EU – Halloween night scene (homepage) ===== */
(function () {
  var CONFIG = {
    start: '2026-10-01T00:00:00+02:00',
    end: '2026-11-01T23:59:59+01:00',
    forceOn: true
  };
  var STORE = '';
  // pink = 150, light pink = 180, purple = 240 (same order as the papmAm bat pictures)
  var PAP_LINKS = [
    { url: STORE + '/search?q=ATSC-150W', label: 'STALEKS EXPERT Donut papmAm, 150 grit' },
    { url: STORE + '/search?q=ATSC-180W', label: 'STALEKS EXPERT Donut papmAm, 180 grit' },
    { url: STORE + '/search?q=ATSC-240W', label: 'STALEKS EXPERT Donut papmAm, 240 grit' }
  ];
  var WITCH_LINK = '/collections/brushes';
  var now = Date.now();
  var on = CONFIG.forceOn || (now >= Date.parse(CONFIG.start) && now <= Date.parse(CONFIG.end));
  if (/[?&]halloween=off/.test(location.search)) on = false;
  if (!on) return;
  var root = document.documentElement;
  root.classList.add('hw-on');
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rand(a, b) { return a + Math.random() * (b - a); }
  function svg(markup, vb) {
    var d = document.createElement('div');
    d.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb + '" aria-hidden="true">' + markup + '</svg>';
    return d.firstChild;
  }
  // baked fog sheet, 1800×560, seamless left to right
  var FOG = 'url("' + window.hwFogImg + '")';
  function fogLayer(h) {
    var l = document.createElement('div');
    var tw = Math.round(h * (1800 / 560));
    l.className = 'hw-cloud';
    l.style.cssText = 'left:0;right:0;top:0;height:' + h + 'px;background-image:' + FOG +
      ';background-size:' + tw + 'px ' + h + 'px;background-position:' + Math.round(rand(0, tw)) + 'px 0;';
    return l;
  }
  function cloud(parent, x, y, w, h, opts) {
    opts = opts || {};
    var box = document.createElement('div');
    box.style.cssText = 'position:absolute;left:' + x + 'px;top:' + y + 'px;width:' + w + 'px;height:' + h + 'px;' +
      '-webkit-mask-image:radial-gradient(ellipse ' + (opts.mx || 50) + '% ' + (opts.my || 50) + '% at 50% ' + (opts.cy || 55) + '%,#000 35%,transparent 72%);' +
      'mask-image:radial-gradient(ellipse ' + (opts.mx || 50) + '% ' + (opts.my || 50) + '% at 50% ' + (opts.cy || 55) + '%,#000 35%,transparent 72%);opacity:' + (opts.o || 1);
    box.appendChild(fogLayer(h));
    parent.appendChild(box);
    return box;
  }

  var WITCH =
    '<g fill="#2b2540">' +
      '<path d="M8 66L150 52l1 4L9 70z"/>' +
      '<path d="M146 50c14-6 30-14 60-20-8 10-10 16 8 20-18 4-16 10-6 22-28-6-46-10-62-14z"/><path d="M144 49h6v10h-6z"/>' +
      '<path class="cape" d="M84 30c20-4 36 0 52-6 14-4 24-2 40-10-8 14-20 22-36 26-12 4-28 6-42 8z"/>' +
      '<path d="M70 62c2-14 6-24 14-32l16-2c4 12 12 22 30 28l-20 6z"/>' +
      '<path d="M96 60c-4 8-8 14-14 20l4 4c8-6 14-14 20-22z"/><path d="M80 78l-10 4c-2 2 0 4 2 3l16-2z"/>' +
      '<path d="M80 34c-8 8-16 18-22 26l6 2c6-8 14-16 24-24z"/>' +
      '<circle cx="80" cy="22" r="7.5"/><path d="M74 21l-10 5h10z"/>' +
      '<path class="hair" d="M84 18c12 0 20 8 34 8-10 6-24 4-32 0z"/>' +
      '<path d="M62 15c8-3 28-4 38-1-8 3-28 4-38 1z"/>' +
      '<path d="M70 14l22-1c0-7 6-15 20-21-12 0-26 6-42 22z"/>' +
    '</g>';
  var BAT =
    '<g fill="currentColor">' +
      '<path class="wing" d="M46 22C37 11 19 8 2 15c8 3 10 9 8 15 6-4 12-2 14 4 4-6 12-6 16 0 2-4 4-6 6-4z"/>' +
      '<path class="wing" d="M54 22c9-11 27-14 44-7-8 3-10 9-8 15-6-4-12-2-14 4-4-6-12-6-16 0-2-4-4-6-6-4z"/>' +
      '<ellipse cx="50" cy="27" rx="6.5" ry="10"/><path d="M44.5 20 45 9.5l3.6 5.5h2.8L55 9.5l.5 10.5z"/>' +
    '</g>';

  var scene, front, front2, batLayer, bats = [];
  function build() {
    var ss = document.querySelector('.section--slideshow');
    var hero = ss && (ss.querySelector('slideshow-component') || ss.querySelector('.swiper'));
    if (!hero) {                                   // other pages (collections): header sky + witch + fog + bat shadows + purple frames
      root.classList.toggle('hw-grid', !!document.querySelector('main .product-card'));
      buildHeaderSky(document.documentElement.clientWidth < 750);
      gridFog(document.documentElement.clientWidth < 750);
      if (window.hwShadows) window.hwShadows.start();
      return;
    }
    if (scene) scene.remove();
    if (front) front.remove();
    if (front2) front2.remove();
    if (cl) { cl.remove(); cl = null; }
    bats = [];
    var W = document.documentElement.clientWidth, sy = scrollY;
    var R = hero.getBoundingClientRect();
    var top = R.top + sy, bottom = R.bottom + sy, left = R.left, right = W - R.right;
    var tb = document.querySelector('.topbar-section');
    var sceneTop = tb ? tb.getBoundingClientRect().bottom + sy : 0;
    var small = W < 750;
    var compact = !small && W < 1400;     // laptops: no room beside the banner → moon in the top-right corner

    scene = document.createElement('div');
    scene.className = 'hw-scene';
    scene.setAttribute('aria-hidden', 'true');
    scene.style.top = sceneTop + 'px';
    var foot = document.querySelector('[id*=footer]');
    var pageEnd = foot ? foot.getBoundingClientRect().top + sy : document.documentElement.scrollHeight;
    var H = Math.max((bottom - sceneTop) + (small ? 260 : 520), pageEnd - sceneTop);
    scene.style.height = H + 'px';
    var oy = sceneTop; // convert page y → scene y

    var M = small ? 120 : 220;

    // clouds behind: left & right of the banner, and lower down by the tiles
    if (!small) {
      sectionFog(scene, oy, W, H, false);
    } else {
      sectionFog(scene, oy, W, H, true);

    }

    // bats sitting in the side margins (clickable layer above the content)
    if (batLayer) batLayer.remove();
    batLayer = document.createElement('div');
    batLayer.className = 'hw-bats';
    // bats sit in empty gaps between sections, on the side opposite to the creeping fog
    var spots = [], gi = 0;
    var secs = Array.prototype.filter.call(document.querySelectorAll('main .shopify-section'), function (s) { return s.getBoundingClientRect().height > 60; });
    var contentL = 0, contentR = W;
    var pw = document.querySelector('main .page-width');
    if (pw) { var pr = pw.getBoundingClientRect(); contentL = pr.left; contentR = pr.right; }
    var gapN = 0;
    var gaps2 = [];
    for (var si = 0; si < secs.length - 1; si++) {
      var ra = secs[si].getBoundingClientRect(), rb = secs[si + 1].getBoundingClientRect();
      var mA = 0, mB = 1e9;
      Array.prototype.forEach.call(secs[si].querySelectorAll('img, h2, h3, p, a, button, [class*=scrollbar]'), function (e) { var r = e.getBoundingClientRect(); if (r.height && r.width) mA = Math.max(mA, r.bottom); });
      Array.prototype.forEach.call(secs[si + 1].querySelectorAll('img, h2, h3, p, a, button'), function (e) { var r = e.getBoundingClientRect(); if (r.height && r.width) mB = Math.min(mB, r.top); });
      if (!mA) mA = ra.bottom; if (mB === 1e9) mB = rb.top;
      var gap = mB - mA;
      if (gap > 30) gaps2.push({ c: (mA + mB) / 2 + scrollY - oy, h: gap });
      if (gap < (small ? 36 : 54) || spots.length >= 3) continue;
      gapN++;
      var fogLeft = gi % 2 === 0; gi++;
      var size = small ? rand(34, 38) : rand(36, 41);
      size = Math.min(size, (gap - (small ? 12 : 16)) / (2.8 * .56));
      var gy = (mA + mB) / 2 + scrollY - oy - size * 2.8 * .56 / 2;
      var x = fogLeft ? contentR - size * 2.8 - rand(10, 80) : contentL + rand(0, 60);
      if (small) x = fogLeft ? W - size * 2.8 - rand(8, 24) : rand(8, 24);
      // keep clear of the carousel arrows / links (with room for the bigger hover)
      var bwid = size * 2.8, bhei = bwid * .56, pad = 26;
      var clash = function (xx) {
        var vy = gy + oy - scrollY;
        return Array.prototype.some.call(document.querySelectorAll('.swiper-button-prev, .swiper-button-next, main a.btn'), function (o) {
          var q = o.getBoundingClientRect(); if (!q.width) return false;
          return !(q.right < xx - pad || q.left > xx + bwid + pad || q.bottom < vy - pad || q.top > vy + bhei + pad);
        });
      };
      // first try sliding along the same side, away from the arrows
      if (clash(x)) { for (var sh = 60; sh <= 420 && clash(x); sh += 60) { var tx = fogLeft ? x - sh : x + sh; if (!clash(tx)) { x = tx; break; } } }
      if (clash(x)) { var alt = small ? (fogLeft ? rand(8, 24) : W - bwid - rand(8, 24)) : (fogLeft ? contentL + rand(0, 60) : contentR - bwid - rand(10, 80)); if (!clash(alt)) x = alt; else { var mid = (contentL + contentR) / 2 - bwid / 2 + rand(-120, 120); if (!clash(mid)) x = mid; else continue; } }
      x = Math.max((small ? 0 : contentL) + 36, Math.min((small ? W : contentR) - bwid - 36, x));   // room for the swing
      spots.push([x, gy, size]);
      if (false) spots.push([fogLeft ? x - rand(190, 230) : x + rand(190, 230), gy + size * 2.8 * .56 * .15, size * .7]);
    }
    var allSpots = spots.slice();
    spots = spots.slice(0, 2);                     // 3 bats in total: one on top + the pair
    spots.forEach(function (s, i) { s[3] = [0, 1, 0][i]; });
    if (true) {
      // bats peeking in from the screen edges (partly hidden behind the side), one per block
      var PS = small ? 40 : 45, pw2 = PS * 2.8;
      // one bat per block, alternating right / left / right
      // previews can stretch the window to the full page height, so use a sane screen height for spacing
      var VH = Math.min(innerHeight, (window.screen && screen.height) || innerHeight, small ? 900 : 1100);
      var vf = small ? .66 : .9;                     // how much of the bat is visible (laptop: further in from the edge)
      var bh2 = pw2 * .5, vis = pw2 * (vf + .02), pad = 4;
      // text / buttons to keep clear of (scene coordinates)
      var blocks = [];
      Array.prototype.forEach.call(document.querySelectorAll('main h2, main h3, main p, main .product-card__info, main a.btn, main .btn, .swiper-button-prev, .swiper-button-next, main .f-price, main .swiper-scrollbar, main [class*=scrollbar], main .swiper-controls, main .card-media, main .product-card__image-wrapper'), function (el) {
        var q = el.getBoundingClientRect();
        if (/^(H2|H3|P)$/.test(el.tagName)) {
          var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), tn, L = 1e9, T = 1e9, R = -1e9, Bt = -1e9;
          while ((tn = tw.nextNode())) { if (!tn.nodeValue.trim()) continue; var rg = document.createRange(); rg.selectNodeContents(tn);
            Array.prototype.forEach.call(rg.getClientRects(), function (cr) { L = Math.min(L, cr.left); T = Math.min(T, cr.top); R = Math.max(R, cr.right); Bt = Math.max(Bt, cr.bottom); }); }
          if (R > L) q = { left: L, right: R, top: T, bottom: Bt, width: R - L };
        }
        if (q.width) blocks.push({ l: q.left, r: q.right, t: q.top + scrollY - oy, b: q.bottom + scrollY - oy });
      });
      var free = function (right, y) {
        var x0 = right ? W - vis : 0, x1 = right ? W : vis;
        return !blocks.some(function (q) { return !(q.r < x0 - pad || q.l > x1 + pad || q.b < y - pad || q.t > y + bh2 + pad); });
      };
      var promoEl = document.querySelector('[id*=custom_content]');
      var startY = promoEl ? promoEl.getBoundingClientRect().bottom + scrollY - oy - 40 : 0;   // only below the promo cards
      gaps2 = gaps2.filter(function (g) { return g.c > startY; });
      var picked = [], lastY = -1e9, side = true;
      gaps2.forEach(function (g) {
        if (picked.length >= 3 || g.c - lastY < VH * .45) return;
        var done = false;
        (small ? [side, !side] : [side]).some(function (right) {
          return (small ? [0, -10, 10, -20, 20, -30, 30] : [0, -15, 15, -30, 30, -45, 45, -60, 60]).some(function (dy) {
            var y = g.c - bh2 / 2 + dy;
            if (free(right, y)) { picked.push([right ? W - pw2 * vf : -pw2 * (1 - vf), y, PS, picked.length, right ? 'r' : 'l']); lastY = g.c; side = !right; done = true; return true; }
            return false;
          });
        });
      });
      // the third bat lives in the "STALEKS Recommended" block, next to the "Mineral Nail Files" title
      var recH = Array.prototype.filter.call(document.querySelectorAll('[id*=collection_tabs] .tabs__tab-name, [id*=collection_tabs] h2, [id*=collection_tabs] h3'), function (h) { return /Mineral Nail Files/i.test(h.textContent) && h.getBoundingClientRect().height; })[0];
      if (recH) {
        var hr2 = recH.getBoundingClientRect(), hc = (hr2.top + hr2.bottom) / 2 + scrollY - oy;
        picked = picked.filter(function (p) { return Math.abs(p[1] + bh2 / 2 - hc) > VH * .45; }).slice(0, 2);
        var ry = hc - bh2 / 2, rr = true;
        [0, -12, 12, -24, 24].some(function (dy) { if (free(true, ry + dy)) { ry += dy; return true; } return false; }) || (rr = !free(false, ry) ? true : false);
        var lastSide = picked.length ? picked[picked.length - 1][4] : 'l';
        if (!small) rr = lastSide === 'l';
        picked.push([rr ? W - pw2 * vf : -pw2 * (1 - vf), ry, PS, 2, rr ? 'r' : 'l']);
        picked.forEach(function (p, k) { p[3] = k; });
      }
      // laptop: build the set around the Recommended bat (right, beside the banner), strictly alternating sides
      if (recH) {
        var fitY = function (right, y0) { var r = null; [0, -15, 15, -30, 30, -45, 45, -60, 60, -80, 80].some(function (dy) { if (free(right, y0 + dy)) { r = y0 + dy; return true; } return false; }); return r; };
        var ry2 = fitY(true, hc - bh2 / 2), recRight = true;
        if (ry2 == null) { ry2 = fitY(false, hc - bh2 / 2); recRight = false; }
        if (ry2 != null) {
          var res = [{ y: ry2, r: recRight }];
          var minGap = VH * .45;
          var tryList = function (list, startRight) {
            var right = startRight;
            list.forEach(function (g) {
              if (res.length >= 3) return;
              if (res.some(function (q) { return Math.abs(q.y + bh2 / 2 - g.c) < minGap; })) return;
              var y = fitY(right, g.c - bh2 / 2);
              if (y != null) { res.push({ y: y, r: right }); right = !right; }
            });
          };
          tryList(gaps2.filter(function (g) { return g.c < hc; }).sort(function (a, b) { return b.c - a.c; }), !recRight);
          tryList(gaps2.filter(function (g) { return g.c > hc; }).sort(function (a, b) { return a.c - b.c; }), !recRight);
          res.sort(function (a, b) { return a.y - b.y; });
          picked = res.map(function (q, k) { return [q.r ? W - pw2 * vf : -pw2 * (1 - vf), q.y, PS, k, q.r ? 'r' : 'l']; });
        }
      }
      spots = picked;
    } else if (spots[1]) {
      var m = spots[1], mw = m[2] * 2.8, cs = m[2] * .82, cw = cs * 2.8;
      var leftSide = m[0] < W / 2;
      var cx2 = leftSide ? m[0] + mw + rand(26, 46) : m[0] - cw - rand(26, 46);
      spots.splice(2, 0, [cx2, m[1] + mw * .56 * (small ? rand(-.05, .05) : rand(.18, .32)), cs, 2]);
    }
    spots.forEach(function (s, i) {
      var b = document.createElement('div');
      b.className = 'hw-bat';
      b.style.cssText = 'left:' + s[0] + 'px;top:' + (s[1] + oy) + 'px;width:' + s[2] + 'px;transform:rotate(' + rand(-14, 14).toFixed(1) + 'deg)';
      b.title = 'Boo!';
      b.style.setProperty('--f', rand(.26, .36).toFixed(2) + 's');
      b.style.setProperty('--h', rand(3.2, 4.4).toFixed(2) + 's');
      b.style.setProperty('--dx', ((small ? rand(8, 12) : rand(22, 34)) * (Math.random() < .5 ? -1 : 1)).toFixed(0) + 'px');
      if (small) b.classList.add('hw-bat--sm');
      { b.classList.add('hw-bat--peek', s[4] === 'r' ? 'is-r' : 'is-l'); b.style.setProperty('--pk', rand(9, 14).toFixed(1) + 's'); b.style.setProperty('--pkd', (-rand(0, 9)).toFixed(1) + 's'); }
      b.setAttribute('role', 'button');
      b.setAttribute('aria-label', 'Bat');
      if (window.hwPapBats) {
        var ci = s[3] != null ? s[3] : i;
        var pb = window.hwPapBats[ci % window.hwPapBats.length];
        b.classList.add('hw-bat--pap'); b.style.width = (s[2] * 2.8) + 'px';
        var inner = document.createElement('div'); inner.className = 'hw-bat__in';
        inner.style.paddingTop = (pb.ar * 100) + '%';
        [['lw', pb.lp], ['rw', pb.rp], ['root', null], ['body', null]].forEach(function (part) {
          var im = document.createElement('img'); im.decoding = 'async'; im.fetchPriority = 'low'; im.src = pb[part[0]]; im.alt = ''; im.className = 'hw-pb-' + part[0];
          if (part[1]) im.style.transformOrigin = (part[1][0] * 100) + '% ' + (part[1][1] * 100) + '%';
          inner.appendChild(im);
        });
        b.appendChild(inner);
      } else b.appendChild(svg(BAT, '0 0 100 50'));
      var link = window.hwPapBats ? PAP_LINKS[(s[3] != null ? s[3] : i) % PAP_LINKS.length] : null;
      if (link) { b.setAttribute('aria-label', link.label); b.title = link.label; b.tabIndex = 0; }
      var go = function (e) {
        e.preventDefault(); e.stopPropagation();
        flyBat(b);
        if (link) setTimeout(function () { location.href = link.url; }, reduced ? 0 : 800);   // a quick flap, then to the product
      };
      b.addEventListener('click', go);
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
      batLayer.appendChild(b);
      bats.push(b);
    });
    document.body.insertBefore(scene, document.body.firstChild);
    document.body.appendChild(batLayer);
    batLayer.style.height = document.documentElement.scrollHeight + 'px';   // clip bats that peek past the screen edge

    // clouds in front of the banner's bottom edge
    front = document.createElement('div');
    front.className = 'hw-front';
    front.setAttribute('aria-hidden', 'true');
    var sr = ss.getBoundingClientRect();
    var hb = R.bottom - sr.top, hl = R.left - sr.left, hw = R.width;
    front.style.top = (hb - (small ? 50 : 100)) + 'px';
    front.style.height = (small ? 140 : 260) + 'px';
    front.style.left = '0'; front.style.right = '0';
    var fh = small ? 140 : 260;
    if (!small) cloud(front, hl - hw * .2, 0, hw * .34, fh, { my: 46, o: .95 });
    if (!small) cloud(front, hl + hw * .86, -10, hw * .34, fh, { my: 46, o: .95 });
    ss.appendChild(front);

    buildHeaderSky(small);
    pumpkinCategories();
  }


  // a few compact, solid cloud puffs, only in empty gaps between sections
  function puff(parent, x, y, w, h) {
    var p = document.createElement('div');
    p.className = 'hw-puff';
    p.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + w + 'px;height:' + h + 'px';
    var n = 6;
    // flat soft base
    var base = document.createElement('i');
    base.className = 'hw-puff__b';
    base.style.cssText = 'left:4%;width:92%;top:48%;height:46%';
    p.appendChild(base);
    for (var i = 0; i < n; i++) {
      var t = i / (n - 1), hump = Math.sin(Math.PI * t);
      var d = h * (.55 + hump * rand(.35, .5));                       // bigger in the middle
      var c = document.createElement('i');
      c.className = 'hw-puff__c';
      c.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (w * (.1 + .8 * t) - d / 2) + 'px;top:' + (h * .72 - d * .78) + 'px';
      p.appendChild(c);
    }
    parent.appendChild(p);
  }
  function sectionFog(scene, oy, W, H, small) {
    var secs = Array.prototype.filter.call(document.querySelectorAll('main .shopify-section'), function (s) {
      var r = s.getBoundingClientRect(); return r.height > 60;
    });
    var sy = scrollY, gaps = [];
    for (var i = 0; i < secs.length - 1; i++) {
      var a = secs[i].getBoundingClientRect(), b = secs[i + 1].getBoundingClientRect();
      // real empty space: from the last visible thing in section i to the first in i+1
      var lastA = a.bottom, firstB = b.top;
      var ca = secs[i].querySelectorAll('img, h2, h3, p, a, button, .swiper-scrollbar, [class*=scrollbar]'), cb = secs[i + 1].querySelectorAll('img, h2, h3, p, a, button');
      var mA = 0, mB = 1e9;
      Array.prototype.forEach.call(ca, function (e) { var r = e.getBoundingClientRect(); if (r.height && r.width) mA = Math.max(mA, r.bottom); });
      Array.prototype.forEach.call(cb, function (e) { var r = e.getBoundingClientRect(); if (r.height && r.width) mB = Math.min(mB, r.top); });
      if (mA) lastA = mA; if (mB < 1e9) firstB = mB;
      var gap = firstB - lastA;
      if (gap > (small ? 40 : 60)) gaps.push({ y: (lastA + firstB) / 2 + sy - oy, h: gap });
    }
    var used = 0;
    gaps.forEach(function (g, i) {
      if (used >= (small ? 3 : 5)) return;
      var fromRight = used % 2 === 1;
      var fh = Math.max(small ? 60 : 90, Math.min(small ? 110 : 190, g.h * 1.6));
      var fw = W * (small ? .75 : rand(.42, .55));
      creep(creepLayer(scene), fromRight, g.y - fh / 2 + parseFloat(scene.style.top || 0), fw, fh, W);
      used++;
    });
  }
  // product grids (collections): soft fog creeping in from the page edges between the rows of cards,
  // drawn BEHIND the cards so it never covers photos, names or prices
  function gridFog(small) {
    if (cl) { cl.remove(); cl = null; }
    var cards = document.querySelectorAll('main .product-card');
    if (!cards.length) return;
    var map = {}, sy = scrollY, W = document.documentElement.clientWidth;
    Array.prototype.forEach.call(cards, function (c) {
      var r = c.getBoundingClientRect(); if (!r.width) return;
      var k = Math.round((r.top + sy) / 30), o = map[k] = map[k] || { top: 1e9, bot: 0 };
      o.top = Math.min(o.top, r.top + sy); o.bot = Math.max(o.bot, r.bottom + sy);
    });
    var rows = Object.keys(map).map(function (k) { return map[k]; }).sort(function (a, b) { return a.top - b.top; });
    var layer = creepLayer(); layer.classList.add('hw-creeps--back');
    var fh = small ? 110 : 170;
    // top: beside the collection title, creeping in from the right so the title and breadcrumbs stay clear
    var title = document.querySelector('main h1');
    if (title) {
      var tr = title.getBoundingClientRect(), y0 = (tr.top + tr.bottom) / 2 + sy;
      var room = W - tr.right - 30;
      creep(layer, true, y0 - fh / 2, Math.max(small ? 150 : 300, Math.min(room, W * (small ? .55 : .5))), fh, W);
    }
    // bottom: under the last row, from both edges, leaving the middle ("Show more") free
    var last = rows[rows.length - 1], more = Array.prototype.filter.call(document.querySelectorAll('main a, main button'), function (b) { return /show more|load more|pokaż więcej|daha fazla göster/i.test(b.textContent) && b.getBoundingClientRect().height; })[0];
    var yb = last.bot + (more ? (more.getBoundingClientRect().bottom + sy - last.bot) : 40) + fh * .15;
    creep(layer, false, yb - fh / 2, W * (small ? .42 : .34), fh, W);
    creep(layer, true, yb - fh / 2 + 12, W * (small ? .42 : .34), fh, W);
  }
  // creeping fog sits above the page backgrounds (sections are white), only in empty gaps
  var cl;
  function creepLayer() {
    if (cl && cl.parentNode) return cl;
    cl = document.createElement('div');
    cl.className = 'hw-creeps';
    cl.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cl);
    return cl;
  }
  // fog that creeps in from the page edge: textured, fading towards the middle, slowly in and out
  function creep(parent, fromRight, y, w, h, W) {
    var wrap = document.createElement('div');
    wrap.className = 'hw-creep' + (fromRight ? ' is-r' : '');
    wrap.style.cssText = (fromRight ? 'right:0;' : 'left:0;') + 'top:' + y + 'px;width:' + w + 'px;height:' + h + 'px';
    var inner = document.createElement('div');
    inner.className = 'hw-creep__in';
    wrap.appendChild(inner);
    inner.appendChild(fogLayer(h));
    parent.appendChild(wrap);
  }


  // category circles become light pumpkin silhouettes with a thin glowing orange outline
  var PK_BODY = 'M50 34C41 29 27 29 17 35C5 42 1 57 3 73C5 91 15 104 31 106C39 107 45 104 50 104C55 104 61 107 69 106C85 104 95 91 97 73C99 57 95 42 83 35C73 29 59 29 50 34Z';
  var PK_STEMS = [
    'M49 34C48 25 46 17 50 10C54 4 62 6 60 12C58 16 53 14 54 11',
    'M50 34C51 26 54 19 61 13',
    'M48 34C47 24 50 15 49 8C52 12 52 22 52 34',
    'M50 34C49 26 51 18 57 14C62 11 65 16 61 19C58 21 55 19 57 16',
    'M47 34C47 27 46 21 49 16C51 13 53 18 55 15'
  ];
  function pkSvg(stem, cls, body, stroke) {
    return '<svg class="' + cls + '" viewBox="0 0 100 110" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="' + PK_BODY + '" ' + body + '/>' +
      '<path d="' + stem + '" fill="none" stroke-linecap="round" stroke-linejoin="round" ' + stroke + '/></svg>';
  }
  // lobed pumpkin silhouettes: 3 lobes (union = outline), faint seams between lobes, a stem
  var PK_SHAPES = [
    { d: 21, r1: 23, r2: 25, rc: 37, rs: 33 },   // round
    { d: 19, r1: 17, r2: 20, rc: 44, rs: 40 },   // tall
    { d: 26, r1: 24, r2: 25, rc: 30, rs: 27 },   // squat
    { d: 23, r1: 23, r2: 25, rc: 39, rs: 35 },   // big round
    { d: 20, r1: 18, r2: 21, rc: 40, rs: 37 }    // slim
  ];
  var PK_STEMS2 = [
    'M0 0C-1 -8 -2 -15 2 -21C5 -26 12 -24 10 -18C8 -14 4 -16 5 -19',
    'M0 0C1 -7 4 -13 10 -17',
    'M-1 0C-2 -9 1 -16 -1 -22C3 -18 3 -9 2 0',
    'M0 0C-1 -8 1 -15 7 -19C12 -21 14 -16 10 -14C7 -13 6 -16 8 -17',
    'M-1 0C-1 -6 -2 -11 1 -15C3 -18 5 -14 7 -16'
  ];
  function pkSVG(i, toolSrc) {
    var s = PK_SHAPES[i % PK_SHAPES.length], st = PK_STEMS2[(i * 2 + 1) % PK_STEMS2.length];
    var leaf = i % 3 === 2;
    var W = 2 * (s.d + s.r2) + 8, B0 = 104, top = B0 - 2 * s.rc, VH = B0 + 4;
    var cx = W / 2, ys = 24;                                     // room for the stem
    var L = [[cx - s.d, B0 - s.rs, s.r2, s.rs], [cx + s.d, B0 - s.rs, s.r2, s.rs], [cx, B0 - s.rc, s.r1, s.rc]];
    var ell = function (e, attrs) { return '<ellipse cx="' + e[0] + '" cy="' + (e[1] + ys) + '" rx="' + e[2] + '" ry="' + e[3] + '" ' + attrs + '/>'; };
    var stem = '<path transform="translate(' + cx + ' ' + (top + ys + 3) + ')" d="' + st + '" fill="none" stroke-linecap="round" stroke-linejoin="round" ';
    var leafP = leaf ? '<path transform="translate(' + (cx + 6) + ' ' + (top + ys - 8) + ')" d="M0 0C4 -8 12 -9 16 -6C13 0 6 3 0 0Z" ' : '';
    var id = 'pkc' + i, H = VH + ys;
    var body = L.map(function (e) { return ell(e, ''); }).join('');
    var tool = Math.min(H * .66, 2 * s.rc * 1.02), tx = cx - tool / 2, ty = ys + B0 - s.rc - tool * .5;
    return '<svg class="hw-pksvg" viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<defs><clipPath id="' + id + '">' + body + '</clipPath></defs>' +
      '<g class="hw-pkglowg">' +
        L.map(function (e) { return ell(e, 'fill="#f39a3c" stroke="#f39a3c" stroke-width="2.6"'); }).join('') +
        stem + 'stroke="#f39a3c" stroke-width="8"/>' + (leaf ? leafP + 'fill="#f39a3c" stroke="#f39a3c" stroke-width="3"/>' : '') +
      '</g>' +
      stem + 'stroke="#efefef" stroke-width="5.4"/>' + (leaf ? leafP + 'fill="#efefef"/>' : '') +
      L.map(function (e) { return ell(e, 'fill="#efefef"'); }).join('') +
      (toolSrc ? '<image clip-path="url(#' + id + ')" href="' + toolSrc + '" x="' + tx + '" y="' + ty + '" width="' + tool + '" height="' + tool + '" preserveAspectRatio="xMidYMid meet" style="mix-blend-mode:darken"/>' : '') +
      '<filter id="' + id + 'b"><feComponentTransfer><feFuncR type="linear" slope="1.075"/><feFuncG type="linear" slope="1.075"/><feFuncB type="linear" slope="1.075"/></feComponentTransfer></filter>' +
      '</svg>';
  }
  function pumpkinBurst(card) {
    var w = card.querySelector('.hw-pkwrap'); if (!w) return;
    var r = w.getBoundingClientRect(), cx = r.left + r.width / 2 + scrollX, cy = r.top + r.height * .58 + scrollY;
    for (var i = 0; i < 20; i++) {
      var s = document.createElement('span');
      s.className = 'hw-pkspark';
      var ang = rand(0, Math.PI * 2), dist = rand(50, 110);
      s.style.left = cx + 'px'; s.style.top = cy + 'px';
      s.style.setProperty('--tx', (Math.cos(ang) * dist).toFixed(0) + 'px');
      s.style.setProperty('--ty', (Math.sin(ang) * dist - 20).toFixed(0) + 'px');
      s.style.background = ['#f39a3c', '#ffd27a', '#e4007c', '#fff'][i % 4];
      document.body.appendChild(s);
      setTimeout(function (el) { el.remove(); }.bind(null, s), 900);
    }
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.hw-pk-card');
    if (!card) return;
    var href = card.getAttribute('href');
    if (href && href !== '#' && !reduced) { e.preventDefault(); setTimeout(function () { location.href = href; }, 420); }
  });

  function pumpkinCategories() {
    var cards = document.querySelectorAll('[id*=collection_list_slider] .collection-card__image');
    var HH = innerWidth < 750 ? 100 : 124;
    Array.prototype.forEach.call(cards, function (c, i) {
      var a = c.parentElement; if (!a) return;
      Array.prototype.forEach.call(a.querySelectorAll('.hw-pkm, .hw-pkglow, .hw-pkwrap'), function (x) { x.remove(); });
      var img = c.querySelector('img'); var src = img && (img.currentSrc || img.src);
      var wrap = document.createElement('div');
      wrap.className = 'hw-pkwrap';
      wrap.innerHTML = pkSVG(i, src);
      var svgEl = wrap.firstChild, vb = svgEl.viewBox.baseVal;
      wrap.style.height = HH + 'px'; wrap.style.width = (HH * vb.width / vb.height) + 'px';
      a.classList.add('hw-pk-card');
      c.style.display = 'none';
      a.insertBefore(wrap, c);
    });
  }


  // ---------- papmAm bats visiting the promo cards ----------
  function makePapBat(idx, width) {
    var pb = window.hwPapBats[idx % window.hwPapBats.length];
    var el = document.createElement('div');
    el.className = 'hw-visitor';
    el.style.width = width + 'px';
    var inner = document.createElement('div');
    inner.className = 'hw-visitor__in';
    inner.style.paddingTop = (pb.ar * 100) + '%';
    [['lw', pb.lp], ['rw', pb.rp], ['root', null], ['body', null]].forEach(function (part) {
      var im = document.createElement('img'); im.decoding = 'async'; im.fetchPriority = 'low'; im.src = pb[part[0]]; im.alt = ''; im.className = 'hw-pb-' + part[0];
      if (part[1]) im.style.transformOrigin = (part[1][0] * 100) + '% ' + (part[1][1] * 100) + '%';
      inner.appendChild(im);
    });
    el.appendChild(inner);
    el._ar = pb.ar;
    return el;
  }
  function visitorLayer(under) {
    var cls = under ? 'hw-visitors hw-visitors--under' : 'hw-visitors';
    var l = document.querySelector(under ? '.hw-visitors--under' : '.hw-visitors:not(.hw-visitors--under)');
    if (!l) { l = document.createElement('div'); l.className = cls; l.setAttribute('aria-hidden', 'true'); document.body.appendChild(l); }
    return l;
  }
  var visitors = 0, usedCards = [], visitIdx = 0;
  function bezier(p0, p1, p2, t) { var u = 1 - t; return u * u * p0 + 2 * u * t * p1 + t * t * p2; }
  function fly(el, from, ctrl, to, dur, done) {
    var t0 = null, lastX = from.x;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;   // ease in-out
      var x = bezier(from.x, ctrl.x, to.x, e), y = bezier(from.y, ctrl.y, to.y, e) + Math.sin(k * Math.PI * 4) * 5 * (1 - k);
      var bank = Math.max(-14, Math.min(14, (x - lastX) * 1.2)); lastX = x;
      el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + bank.toFixed(1) + 'deg)';
      if (k < 1) requestAnimationFrame(step); else done && done();
    }
    requestAnimationFrame(step);
  }
  function visitPromo() {
    if (reduced || document.hidden || !window.hwPapBats || visitors >= 1) return;
    var cards = Array.prototype.filter.call(document.querySelectorAll('[id*=custom_content] [data-block-type] .card-media, [id*=featured_collection] .product-card__image-wrapper, [id*=collection_tabs] .card-media, [id*=collection_tabs] .media-wrapper'), function (c) {
      var r = c.getBoundingClientRect(), hb = (document.querySelector('.header-section') || document.body).getBoundingClientRect().bottom;
      var vw = document.documentElement.clientWidth;
      return r.top > hb + 110 && r.top < innerHeight - 160 && r.width > 120 && r.left >= 8 && r.right <= vw - 8 && usedCards.indexOf(c) < 0;
    });
    if (!cards.length) return;
    var W = document.documentElement.clientWidth, small = W < 750;
    // things a perched bat must not cover: other cards, headings, category labels, product cards, other bats
    var obst = [];
    Array.prototype.forEach.call(document.querySelectorAll('[id*=custom_content] .card-media, main h2, main h3, main a.btn, main .link, .collection-card__inner, .hw-pkwrap, .product-card, .hw-visitor, .hw-bat, .swiper-button-prev, .swiper-button-next'), function (o) {
      var q = o.getBoundingClientRect();
      if (/^H[23]$/.test(o.tagName)) {
        var tw = document.createTreeWalker(o, NodeFilter.SHOW_TEXT), tn, L = 1e9, T = 1e9, R = -1e9, Bm = -1e9;
        while ((tn = tw.nextNode())) { if (!tn.nodeValue.trim()) continue; var rg = document.createRange(); rg.selectNodeContents(tn);
          Array.prototype.forEach.call(rg.getClientRects(), function (cr) { L = Math.min(L, cr.left); T = Math.min(T, cr.top); R = Math.max(R, cr.right); Bm = Math.max(Bm, cr.bottom); }); }
        if (R > L) q = { left: L, top: T, right: R, bottom: Bm, width: R - L, height: Bm - T };
      }
      if (q.width && q.height) obst.push({ el: o, r: q });
    });
    var hits = function (x0, y0, x1, y1, self) {
      return obst.some(function (o) { return o.el !== self && !o.el.contains(self) && !self.contains(o.el) && !(o.r.right < x0 || o.r.left > x1 || o.r.bottom < y0 || o.r.top > y1); });
    };
    var choice = null;
    cards.sort(function () { return Math.random() - .5; }).some(function (c) {
      var rc = c.getBoundingClientRect(), ar = window.hwPapBats[visitIdx % 3].ar;
      for (var bw0 = Math.min(small ? 96 : 130, rc.width * .42); bw0 >= (small ? 60 : 72); bw0 -= 8) {
        var bh0 = bw0 * ar, fs = [rand(.12, .35), rand(.4, .6), rand(.65, .85)].sort(function () { return Math.random() - .5; });
        for (var fi = 0; fi < fs.length; fi++) {
          var x0 = Math.max(rc.left + 4, Math.min(rc.right - bw0 - 4, rc.left + rc.width * fs[fi] - bw0 / 2)), y0 = rc.top - bh0 * .92;
          if (!hits(x0, y0, x0 + bw0, rc.top - 2, c)) { choice = { card: c, r: rc, bw: bw0, bh: bh0, x: x0, y: y0 }; return true; }
        }
      }
      return false;
    });
    if (!choice) return;
    var card = choice.card, r = choice.r, bw = choice.bw, bh = choice.bh;
    var el = makePapBat(visitIdx++, bw);
    visitorLayer().appendChild(el);
    visitors++; usedCards.push(card);
    // perch on the top edge, left half of the card (the Save % badge sits top-right)
    var sx = scrollX, sy = scrollY;
    var px = choice.x + sx, py = choice.y + sy;
    var fromLeft = Math.random() < .5;
    var start = { x: (fromLeft ? -bw - 40 : W + 40) + sx, y: r.top + sy - rand(160, 260) };
    var ctrl = { x: (start.x + px) / 2, y: Math.min(start.y, py) - rand(60, 140) };
    el.classList.add('is-flying');
    fly(el, start, ctrl, { x: px, y: py }, rand(3800, 4600), function () {
      el.classList.remove('is-flying'); el.classList.add('is-landed');
      setTimeout(function () { el.classList.add('is-folded'); }, 260);
      setTimeout(function () {
        el.classList.remove('is-folded');
        setTimeout(function () {
          el.classList.remove('is-landed'); el.classList.add('is-flying');
          var away = { x: (Math.random() < .5 ? -bw - 60 : W + 60) + scrollX, y: py - rand(220, 360) };
          fly(el, { x: px, y: py }, { x: px + (away.x - px) * .3, y: py - rand(120, 200) }, away, rand(3400, 4200), function () {
            el.remove(); visitors--; usedCards.splice(usedCards.indexOf(card), 1);
          });
        }, 380);
      }, rand(2600, 4200));
    });
  }

  // a bat swoops down and slips under a promo picture, coming out on the other side
  function flyUnder(ch) {
    var r = ch.r, bw = ch.bw, W = document.documentElement.clientWidth, sx = scrollX, sy = scrollY;
    var el = makePapBat(visitIdx++, bw);
    visitorLayer(true).appendChild(el);
    visitors++; usedCards.push(ch.card);
    var ltr = Math.random() < .5;
    var start = { x: (ltr ? -bw - 40 : W + 40) + sx, y: r.top + sy - rand(120, 220) };
    var mid = { x: r.left + sx + r.width / 2 - bw / 2, y: r.top + sy + r.height * rand(.25, .4) };
    var end = { x: (ltr ? W + 60 : -bw - 60) + sx, y: r.top + sy - rand(80, 200) };
    el.classList.add('is-flying');
    fly(el, start, { x: (start.x + mid.x) / 2, y: start.y + 40 }, mid, rand(1700, 2200), function () {
      fly(el, mid, { x: (mid.x + end.x) / 2, y: mid.y + 30 }, end, rand(1700, 2200), function () {
        el.remove(); visitors--; usedCards.splice(usedCards.indexOf(ch.card), 1);
      });
    });
  }

  // ---------- phone: bats fly in from the side and sit on the section titles ----------
  var perchSet = false;
  function textRect(h) {
    var tw = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), tn, L = 1e9, T = 1e9, R = -1e9, Bm = -1e9;
    while ((tn = tw.nextNode())) { if (!tn.nodeValue.trim()) continue; var rg = document.createRange(); rg.selectNodeContents(tn);
      Array.prototype.forEach.call(rg.getClientRects(), function (cr) { L = Math.min(L, cr.left); T = Math.min(T, cr.top); R = Math.max(R, cr.right); Bm = Math.max(Bm, cr.bottom); }); }
    return R > L ? { left: L, top: T, right: R, bottom: Bm, width: R - L } : null;
  }
  function setupHeadingPerch() {
    if (perchSet || !window.hwPapBats || !('IntersectionObserver' in window)) return;
    perchSet = true;
    var heads = Array.prototype.filter.call(document.querySelectorAll('[id*=featured_collection] h2, [id*=collection_tabs] h2'), function (h) { return textRect(h); }).slice(0, 3);
    heads.forEach(function (h, i) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { perchOn(h, i); }, 300);
      }, { threshold: 1, rootMargin: '0px 0px -25% 0px' });
      io.observe(h);
    });
  }
  function perchOn(h, i) {
    var tr = textRect(h); if (!tr) return;
    var W = document.documentElement.clientWidth, sx = scrollX, sy = scrollY;
    var bw = 66, bh = bw * window.hwPapBats[i % 3].ar;
    var el = makePapBat(i, bw);
    el.classList.add('hw-percher');
    var link = PAP_LINKS[i % PAP_LINKS.length];
    el.setAttribute('role', 'button'); el.setAttribute('aria-label', link.label);
    el.addEventListener('click', function () { location.href = link.url; });
    visitorLayer().appendChild(el);
    // sit on the top of the letters, towards the end of the title
    var px = tr.left + sx + tr.width * rand(.55, .8) - bw / 2, py = tr.top + sy - bh * .86;
    px = Math.max(8, Math.min(W - bw - 8, px));
    var fromLeft = i % 2 === 1;
    var start = { x: (fromLeft ? -bw - 30 : W + 30) + sx, y: py - rand(90, 150) };
    el.classList.add('is-flying');
    fly(el, start, { x: (start.x + px) / 2, y: Math.min(start.y, py) - 40 }, { x: px, y: py }, rand(2600, 3200), function () {
      el.classList.remove('is-flying'); el.classList.add('is-landed');
      setTimeout(function () { el.classList.add('is-folded'); }, 260);
      // now and then it stretches its wings and folds them again
      setInterval(function () {
        if (document.hidden) return;
        el.classList.remove('is-folded');
        setTimeout(function () { el.classList.add('is-folded'); }, 900);
      }, rand(6000, 9000));
    });
  }
  (function watchPage() {
    var promo = document.querySelector('[id*=custom_content]');
    setTimeout(function loop() {
      var started = promo && promo.getBoundingClientRect().top < innerHeight * .8;
      if (false && started && !document.hidden) visitPromo();
      setTimeout(loop, visitors ? 1500 : rand(3500, 6000));
    }, 1500);
  })();

  // ---------- night sky in the header ----------
  var hsBottom;
  function buildHeaderSky(small) {
    var hs = document.querySelector('.header-section');
    if (!hs) return;
    if (strip) strip.remove();
    if (hsBottom) hsBottom.remove();
    var hr = hs.getBoundingClientRect(), SW = hr.width, SH = hr.height;
    strip = document.createElement('div');
    strip.className = 'hw-headsky';
    strip.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < (small ? 16 : 36); i++) {
      var s = document.createElement('span');
      s.className = 'hw-star';
      var z = rand(1, 2.4);
      s.style.cssText = 'left:' + rand(0, 100) + '%;top:' + rand(3, 85) + '%;width:' + z + 'px;height:' + z + 'px;animation-delay:' + (-rand(0, 4)) + 's;animation-duration:' + rand(2.5, 5) + 's';
      strip.appendChild(s);
    }
    // moon between the logo and the account link (small screens: top-right corner)
    var logo = Array.prototype.filter.call(hs.querySelectorAll('img.logo, .header__heading-logo, .logo img'), function (e) { return e.getBoundingClientRect().width > 0; })[0];
    var acc = hs.querySelector('.account-button') || hs.querySelector('a[href*="account"], .header__icon--account');
    var lr = logo ? logo.getBoundingClientRect() : null, ar = acc ? acc.getBoundingClientRect() : null;
    var D, mcx, mcy;
    if (lr && ar && ar.left - lr.right > 40) {
      var gap = ar.left - lr.right;
      D = small ? Math.max(22, Math.min(44, gap - 16)) : Math.min(SH * .78, gap * .55, 150);
      var pad = small ? 8 : 14;
      var besideLogo = (lr.right - hr.left) + pad + D / 2;
      var beforeAccount = (ar.left - hr.left) - 10 - D / 2;
      mcx = Math.min(besideLogo, beforeAccount);
      mcy = small ? (lr.top + lr.bottom) / 2 - hr.top : SH * .42;
    } else {
      D = 26; mcx = (lr ? lr.right - hr.left + 22 : SW / 2); mcy = 18;
    }
    var glow = document.createElement('div');
    glow.className = 'hw-strip-glow';
    glow.style.cssText = 'left:' + (mcx - D * 1.4) + 'px;top:' + (mcy - D * 1.4) + 'px;width:' + D * 2.8 + 'px;height:' + D * 2.8 + 'px';
    strip.appendChild(glow);
    var moon;
    if (window.hwMoonImg) {
      var MS = D / .632;
      moon = document.createElement('img');
      moon.decoding = 'async'; moon.fetchPriority = 'low';
      moon.src = window.hwMoonImg; moon.alt = '';
      moon.className = 'hw-moon-img';
      moon.style.cssText = 'left:' + (mcx - MS * .542) + 'px;top:' + (mcy - MS * .398) + 'px;width:' + MS + 'px';
    } else {
      moon = document.createElement('div');
      moon.className = 'hw-moon';
      moon.style.cssText = 'left:' + (mcx - D / 2) + 'px;top:' + (mcy - D / 2) + 'px;width:' + D + 'px;height:' + D + 'px';
    }
    strip.appendChild(moon);
    strip._moon = { x: mcx, y: mcy, D: D, W: SW, H: SH };
    // soft clouds low in the sky (kept faint so the menu stays readable)
    if (!small) {
      // small cloud under the moon, kept above the menu row
      var navTop = (hs.querySelector('.header__bottom') || hs).getBoundingClientRect().top - hr.top;
      var ch = Math.max(20, Math.min(D * .55, navTop - (mcy + D * .1)));
      var mcl = cloud(strip, mcx - D * 1.1, navTop - ch, D * 2.2, ch, { my: 40, o: .55, cy: 60 }); mcl.classList.add('hw-mooncloud');
    }
    var mc = strip.querySelector('.hw-mooncloud');
    if (mc) mc.style.top = (strip._moon.y + strip._moon.D * .42 - parseFloat(mc.style.height) / 2) + 'px';
    hs.insertBefore(strip, hs.firstChild);
    // clouds along the header's bottom edge, spilling a little onto the page
    hsBottom = document.createElement('div');
    hsBottom.className = 'hw-headclouds';
    hsBottom.setAttribute('aria-hidden', 'true');
    var bh = small ? 50 : 72;
    hsBottom.style.cssText = 'top:' + (SH - bh * .35) + 'px;height:' + bh + 'px';
    var fade = 'linear-gradient(#000 0,#000 ' + Math.round(bh * .3) + 'px,rgba(0,0,0,.35) ' + Math.round(bh * .48) + 'px,transparent ' + Math.round(bh * .75) + 'px)';
    var band = document.createElement('div');
    band.style.cssText = 'position:absolute;left:0;right:0;top:0;height:' + bh + 'px;-webkit-mask-image:' + fade + ';mask-image:' + fade;
    hsBottom.appendChild(band);
    // one even band: many wide, overlapping puffs
    for (var x = -SW * .12; x < SW * 1.05; x += SW * (small ? .22 : .16)) cloud(band, x + rand(-10, 10), rand(-2, 3), SW * (small ? .5 : .34), bh, { my: 46, mx: 62, o: small ? .7 : .85 });
    hs.appendChild(hsBottom);
  }

  // ---------- night strip above the banner ----------
  var strip;
  function buildStrip(ss, hero, small) {
    if (strip) strip.remove();
    strip = document.createElement('div');
    strip.className = 'hw-strip';
    strip.setAttribute('aria-hidden', 'true');
    var SW = hero.getBoundingClientRect().width, SH = small ? 120 : Math.round(Math.max(150, Math.min(200, SW * .14)));
    strip.style.height = SH + 'px';
    // stars
    for (var i = 0; i < (small ? 28 : 70); i++) {
      var s = document.createElement('span');
      s.className = 'hw-star';
      var z = rand(1, 2.6);
      s.style.cssText = 'left:' + rand(0, 100) + '%;top:' + rand(2, 70) + '%;width:' + z + 'px;height:' + z + 'px;animation-delay:' + (-rand(0, 4)) + 's;animation-duration:' + rand(2.5, 5) + 's';
      strip.appendChild(s);
    }
    // moon (right side)
    var D = SH * (small ? .78 : .82), mcx = SW - SH * (small ? .75 : 1.2), mcy = SH * .48;
    var glow = document.createElement('div');
    glow.className = 'hw-strip-glow';
    glow.style.cssText = 'left:' + (mcx - D * 1.3) + 'px;top:' + (mcy - D * 1.3) + 'px;width:' + D * 2.6 + 'px;height:' + D * 2.6 + 'px';
    strip.appendChild(glow);
    var moon;
    if (window.hwMoonImg) {
      var MS = D / .632;
      moon = document.createElement('img');
      moon.decoding = 'async'; moon.fetchPriority = 'low';
      moon.src = window.hwMoonImg; moon.alt = '';
      moon.className = 'hw-moon-img';
      moon.style.cssText = 'left:' + (mcx - MS * .542) + 'px;top:' + (mcy - MS * .398) + 'px;width:' + MS + 'px';
    } else {
      moon = document.createElement('div');
      moon.className = 'hw-moon';
      moon.style.cssText = 'left:' + (mcx - D / 2) + 'px;top:' + (mcy - D / 2) + 'px;width:' + D + 'px;height:' + D + 'px';
    }
    strip.appendChild(moon);
    strip._moon = { x: mcx, y: mcy, D: D, W: SW, H: SH };
    // clouds drifting along the bottom and over the moon's lower edge
    cloud(strip, -SW * .05, SH * .45, SW * .55, SH * .9, { my: 46, o: .9 });
    cloud(strip, SW * .35, SH * .55, SW * .45, SH * .8, { my: 44, o: .75 });
    cloud(strip, mcx - D * 1.4, mcy + D * .05, D * 2.8, SH * .75, { my: 44, o: 1 });
    cloud(strip, SW * .6, SH * .62, SW * .5, SH * .7, { my: 44, o: .8 });
    ss.insertBefore(strip, ss.firstChild);
  }

  addEventListener('scroll', function () { root.classList.toggle('hw-scrolled', scrollY > 10); }, { passive: true });

  // a bat comes alive only when clicked: flaps, loops around and lands back
  function flyBat(b, mode) {
    if (b._busy) return;
    b._busy = true;
    b.classList.add('is-active');
    mode = mode || ['loop', 'eight', 'swoop', 'hop'][Math.floor(Math.random() * 4)];
    var base = b.style.transform, t0 = null;
    var dur = reduced ? 600 : mode === 'hop' ? rand(1800, 2300) : rand(3400, 4400);
    var r = rand(35, 70), dir = Math.random() < .5 ? -1 : 1, up = rand(35, 80);
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur), a = k * Math.PI * 2, x, y, rot, sc = 1 + Math.sin(k * Math.PI) * .2;
      if (mode === 'eight') { x = dir * Math.sin(a) * r * 1.5; y = -Math.sin(2 * a) * r * .45 - Math.sin(k * Math.PI) * up * .4; rot = Math.cos(a) * 20 * dir; }
      else if (mode === 'swoop') { x = dir * Math.sin(k * Math.PI) * r * 2; y = Math.sin(k * Math.PI) * up * .7 - Math.sin(a) * 18; rot = Math.cos(k * Math.PI) * -24 * dir; }
      else if (mode === 'hop') { x = dir * Math.sin(a) * 14; y = -Math.abs(Math.sin(k * Math.PI * 2)) * up * .45; rot = Math.sin(a * 2) * 10; sc = 1 + Math.sin(k * Math.PI) * .08; }
      else { x = dir * Math.sin(a) * r * 1.4; y = -Math.sin(k * Math.PI) * up + (1 - Math.cos(a)) * r * .25; rot = Math.cos(a) * 18 * dir; }
      b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + rot.toFixed(1) + 'deg) scale(' + sc.toFixed(3) + ')';
      if (k < 1) requestAnimationFrame(step);
      else { b.style.transform = base; b.classList.remove('is-active'); b._busy = false; }
    }
    requestAnimationFrame(step);
  }
  // bats take little flights by themselves now and then
  if (false) setInterval(function () {
    if (reduced || document.hidden || !bats.length) return;
    var vis = bats.filter(function (b) { var r = b.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && !b._busy; });
    if (!vis.length) return;
    var n = 1;
    for (var q = 0; q < n && vis.length; q++) { var pick = vis.splice(Math.floor(Math.random() * vis.length), 1)[0]; setTimeout(flyBat.bind(null, pick), q * 300); }
  }, 7000);


  // witch picture with fluttering hair, cape and broom (SVG wave filter on the loose parts only)
  var wid = 0;
  function witchSVG() {
    var sz = window.hwWitchSize || [760, 486], W = sz[0], H = sz[1], id = 'hww' + (++wid), href = window.hwWitchImg;
    // loose parts (fractions of the picture): trailing cape + broom, hair behind the head, cape fringe under the bags
    var loose = [[0, 0, .34, 1], [.34, .14, .14, .14], [.40, .06, .30, .24], [.36, .67, .26, .22]];
    var rects = loose.map(function (r) { return '<rect x="' + r[0] * W + '" y="' + r[1] * H + '" width="' + r[2] * W + '" height="' + r[3] * H + '"/>'; }).join('');
    var x =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true" style="display:block;width:100%;height:auto;overflow:visible">' +
      '<defs>' +
        '<filter id="' + id + 'b" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="' + W * .03 + '"/></filter>' +
        '<mask id="' + id + 'l" maskUnits="userSpaceOnUse" x="-50" y="-50" width="' + (W + 100) + '" height="' + (H + 100) + '"><g fill="#fff" filter="url(#' + id + 'b)">' + rects + '</g></mask>' +
        '<mask id="' + id + 's" maskUnits="userSpaceOnUse" x="-50" y="-50" width="' + (W + 100) + '" height="' + (H + 100) + '"><rect x="-50" y="-50" width="' + (W + 100) + '" height="' + (H + 100) + '" fill="#fff"/><g fill="#000" filter="url(#' + id + 'b)">' + rects + '</g></mask>' +
        '<filter id="' + id + 'w" filterUnits="userSpaceOnUse" x="-60" y="-60" width="' + (W + 120) + '" height="' + (H + 120) + '">' +
          '<feTurbulence type="fractalNoise" baseFrequency="0.0055 0.011" numOctaves="1" seed="4" result="n"/>' +
          '<feOffset in="n" result="m"><animate attributeName="dx" values="0;-60;-20;-80;-10;0" dur="1.4s" repeatCount="indefinite"/>' +
            '<animate attributeName="dy" values="0;24;-14;20;-6;0" dur="1.1s" repeatCount="indefinite"/></feOffset>' +
          '<feDisplacementMap in="SourceGraphic" in2="m" scale="' + W * .05 + '" xChannelSelector="R" yChannelSelector="G"/>' +
        '</filter>' +
      '</defs>' +
      (window.hwPusherImg ? '<image href="' + window.hwPusherImg + '" width="' + W + '" height="' + H + '"/>' : '') +
      '<image href="' + href + '" width="' + W + '" height="' + H + '"/>' +
      '<g mask="url(#' + id + 'l)"><image href="' + href + '" width="' + W + '" height="' + H + '" filter="url(#' + id + 'w)"/></g>' +
      '</svg>';
    var d = document.createElement('div'); d.innerHTML = x; return d.firstChild;
  }
  // the witch crosses the header sky and gets smaller towards the far end
  function witchFlight() {
    if (!strip || !strip._moon || document.hidden || reduced || strip.querySelector('.hw-witch')) return 0;
    var m = strip._moon, img = !!window.hwWitchImg;
    var ww = m.W < 750 ? Math.max(80, m.H * .95) : Math.max(105, Math.min(175, m.H * (img ? 1.15 : .8)));
    var w = document.createElement('div');
    w.className = 'hw-witch' + (img ? ' hw-witch--img' : '');
    w.style.width = ww + 'px';
    w.style.transformOrigin = '50% 50%';
    if (img) w.appendChild(witchSVG());
    else w.appendChild(svg(WITCH, '0 0 220 100'));
    strip.appendChild(w);
    var hgt = ww * (img ? (window.hwWitchSize ? window.hwWitchSize[1] / window.hwWitchSize[0] : .64) : .45);
    // speed follows the header width, so phones are not slow
    var dur = Math.max(5600, Math.min(12500, m.W * 9.5)) * rand(.95, 1.08);
    var x0 = -ww * .6, x1 = m.W - ww * .5, t0 = null, last = 0;
    var y0 = Math.max(2, (m.H - hgt) / 2 + 2), y1 = m.H * .22 - hgt / 2;
    var bob = m.H * (m.W < 750 ? .045 : .08), waves = rand(1.6, 2.2);
    if (m.W < 750) { y0 = Math.max(y0, 4); y1 = Math.max(y1, 0); }
    // tail of the brush in the picture (fractions) – the glowing trail comes from here
    var tx = img ? .21 : .05, ty = img ? .86 : .5;
    function step(t) {
      if (!t0) t0 = t;
      var k = (t - t0) / dur;
      if (k >= 1 || !strip.contains(w)) { w.remove(); return; }
      var s = 1 - .74 * Math.pow(k, 1.1);
      var x = x0 + (x1 - x0) * (1 - Math.pow(1 - k, 1.25));
      var ph = k * Math.PI * 2 * waves;
      var y = y0 + (y1 - y0) * k + Math.sin(ph) * bob * (0.5 + .5 * s);
      var tilt = Math.cos(ph) * -4 * (0.5 + .5 * s) - 3 * k;              // nose follows the up/down swing
      var op = k > .86 ? Math.max(0, 1 - (k - .86) / .14) : 1;
      w.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + s.toFixed(3) + ') rotate(' + tilt.toFixed(2) + 'deg)';
      w.style.opacity = op.toFixed(3);
      if (t - last > 45 && op > .15) {
        last = t;
        // brush tail position on screen (rotation around the centre included)
        var dx = (tx - .5) * ww * s, dy = (ty - .5) * hgt * s, r = tilt * Math.PI / 180;
        var px = x + ww / 2 + dx * Math.cos(r) - dy * Math.sin(r), py = y + hgt / 2 + dx * Math.sin(r) + dy * Math.cos(r);
        var sp = document.createElement('span');
        sp.className = 'hw-spark hw-trail';
        var z = Math.max(.4, s) * rand(.7, 1.3);
        sp.style.left = (px + rand(-3, 3)) + 'px';
        sp.style.top = (py + rand(-3, 3)) + 'px';
        sp.style.setProperty('--z', z.toFixed(2));
        sp.style.setProperty('--dy', rand(6, 18).toFixed(0) + 'px');
        strip.appendChild(sp);
        setTimeout(function () { sp.remove(); }, 1400);
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    return dur;
  }
  setTimeout(function loop() {
    var d = witchFlight() || 0;
    setTimeout(loop, d + rand(9000, 14000));                            // pause after she has gone
  }, 2000);
  window.hwWitch = witchFlight;
  document.addEventListener('click', function (e) {
    var w = strip && strip.querySelector('.hw-witch');
    if (!w || e.target.closest('a, button, input, select, textarea, summary, label')) return;
    var r = w.getBoundingClientRect();
    if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
      e.preventDefault(); location.href = WITCH_LINK;
    }
  });
  document.addEventListener('mousemove', function (e) {
    var w = strip && strip.querySelector('.hw-witch'), hs = document.querySelector('.header-section');
    if (!hs) return;
    var on = false;
    if (w && !e.target.closest('a, button, input')) { var r = w.getBoundingClientRect(); on = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom; }
    hs.classList.toggle('hw-witch-hover', on);
  }, { passive: true });

  var rt;
  addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 200); });
  if (document.readyState === 'complete') build(); else addEventListener('load', build);
  setTimeout(build, 600);
})();
